// extracted by mini-css-extract-plugin
export var bullet = "_mx-q";
export var bulletText = "_mx-p";
export var bullets = "_mx-k";
export var callout = "_mx-g";
export var calloutBody = "_mx-i";
export var calloutLabel = "_mx-h";
export var checkIcon = "_mx-m";
export var checkList = "_mx-j";
export var checkSvg = "_mx-n";
export var checkText = "_mx-o";
export var fieldCard = "_mx-1";
export var fieldDescription = "_mx-5";
export var fieldHeader = "_mx-3";
export var fieldTitle = "_mx-4";
export var finalNote = "_mx-s";
export var flow = "_mx-x";
export var flowArrow = "_mx-v";
export var flowStep = "_mx-u";
export var helperText = "_mx-r";
export var inlineTitle = "_mx-t";
export var listItem = "_mx-l";
export var noteBody = "_mx-8";
export var noteBodyText = "_mx-9";
export var noteCard = "_mx-2";
export var noteIcon = "_mx-6";
export var noteTitle = "_mx-7";
export var productChoices = "_mx-w";
export var radioDot = "_mx-d";
export var radioDotSelected = "_mx-e";
export var radioDotSvg = "_mx-f";
export var selectableCard = "_mx-b";
export var selectableCardSelected = "_mx-c";
export var strongText = "_mx-a";
export var subHeading = "_mx-0";